import ufcAPI from "@/api/products/upfrontcosts";

const state = () => ({
  currentUpfrontCosts: [],
  currentUpfrontCostsLoading: false,
});

const mutations = {
  setCurrentUpfrontCosts(state,data){ state.currentUpfrontCosts = data; },
  setCurrentUpfrontCostsLoading(state,data){ state.currentUpfrontCostsLoading = data; },
};

const actions = {
  async fetchUpfrontCostsById({commit,dispatch},pid){
    commit('setCurrentUpfrontCostsLoading',true);
    try{
      const res = await ufcAPI.fetchUpfrontCostsById(pid);
      if(res.status===200){
        commit('setCurrentUpfrontCosts',res.data);
        commit('setCurrentUpfrontCostsLoading',false);
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
    }
  },
  async updateUpfrontCostsById({commit,dispatch},{pid,data}){
    commit('setCurrentUpfrontCostsLoading',true);
    try{
      const res = await ufcAPI.updateUpfrontCostsById(pid,data);
      if(res.status===200){
        commit('setCurrentUpfrontCosts',res.data);
        commit('setCurrentUpfrontCostsLoading',false);
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
        commit('setCurrentUpfrontCostsLoading',false);
        throw res.response.data.message;
      }
    }catch(err){
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
      commit('setCurrentUpfrontCostsLoading',false);
      throw err.response.data.message;
    }
  },
};

const getters = {
  getCurrentUpfrontCosts: (state)=>{
    return state.currentUpfrontCosts.map(e=>{
      return {
        description: e.charge.name,
        option: '',
        quantity: e.quantity,
        unitprice: `£${e.charge.standard_price}`,
        subtotal: `£${(parseFloat(e.charge.standard_price)*e.quantity).toFixed(2)}`,
      };
    }); 
  },
  getCurrentUpfrontCostIds: (state)=>{ return state.currentUpfrontCosts.map(e=>{
    return {id:e.charge_id,quantity:e.quantity};
  }); },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  